import { Directive, ElementRef, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Directive({
	selector: '[scrollTo]',
	standalone: true
})
export class ScrollToDirective implements AfterViewInit {
	firstLoad: boolean = false;
	id: number;

	@Input() set messages(value: Array<any>) {
		this._messages = value;
	};
	@Input() set scrollTo(value: number) {
		this.id = value;
	}

	@Output() showMessage = new EventEmitter<any>();

	constructor(private el: ElementRef) {}

	_messages: Array<any> = [];

	ngAfterViewInit(): void {
		if (this._messages.length) this.scroll(this.id);
	}

	scroll(id: number): void {
		this.el.nativeElement.scrollTop = id;
		if (id) this.showMessage.emit(id);
	}

	scrollTable(id): void {
		const container = this.el.nativeElement;
		const targetElement = container.querySelector(`[id="${String(id)}"]`);

		if (!targetElement) return;

		container.querySelectorAll('.active').forEach((el: Element): void => {
			el.classList.remove('active');
		});

		targetElement.classList.add('active');

		const containerScrollTop = container.scrollTop;
		const containerScrollBottom = containerScrollTop + container.clientHeight;
		const elementTop = targetElement.offsetTop;
		const elementBottom = elementTop + targetElement.offsetHeight;
		const isElementVisible: boolean = elementTop >= containerScrollTop && elementBottom <= containerScrollBottom;

		if (!isElementVisible) {
			const scrollPadding = 20;

			if (elementTop < containerScrollTop) {
				this.smoothScrollTo(container, elementTop - scrollPadding);
			} else {
				this.smoothScrollTo(container, elementBottom - container.clientHeight + scrollPadding);
			}
		}
	}

	private smoothScrollTo(element: HTMLElement, targetPosition: number): void {
		const startPosition: number = element.scrollTop;
		const distance: number = targetPosition - startPosition;
		const duration = 300;
		let startTime: number | null = null;

		const animateScroll: (currentTime: number) => void = (currentTime: number): void => {
			if (startTime === null) startTime = currentTime;
			const timeElapsed: number = currentTime - startTime;
			const progress: number = Math.min(timeElapsed / duration, 1);
			const ease: number = 1 - Math.pow(1 - progress, 3);

			element.scrollTop = startPosition + distance * ease;

			if (progress < 1) {
				requestAnimationFrame(animateScroll);
			}
		};

		requestAnimationFrame(animateScroll);
	}
}